/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { NavigationListSectionItem } from "./section_item";
import { useWebpageSDK } from "cms/components/hooks/use-webpage-sdk";

const NavigationListSection = (props) => {
    
    const { webpage_id } = props || {}; // is webpage.guid
    const { token } = useAuth();
    const { component } = useContext(ContentZoneContext);
    const { fetchWebpageTree } = useWebpageSDK();
    
    const [webpage, setWebpage] = useState(null);
    const [error, setError] = useState(null);
    const { children } = webpage || {};
    
    useEffect(() => {
        const executeAsync = async () => {
            const response = await fetchWebpageTree(token, webpage_id);
            const { error, webpage } = response;
            setError(error);
            setWebpage(webpage);
        };
        executeAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, webpage_id]);
    
  
    const hasContent = isArrayNotEmpty(children);
    const noChildrenMessage = "This page currently has no children.";
    
    return (
        <>
            <EmptyContentMessage
                hasContent={hasContent}
                component={component}
                message={noChildrenMessage}
            />
            {!error && webpage && children &&
                <div className='simplicity-section-list'>
                    <div className='simplicity-section-list-body'>
                        {children.map((item, index) => {
                            return (
                                <NavigationListSectionItem
                                    key={index}
                                    item={item}
                                    webpage={webpage}
                                />
                            );
                        })}
                    </div>
                </div>
            }
            {error && <div className='error'>{error?.message}</div>}
            {/*{error && <div className='error'>{JSON.stringify(error)}</div>}*/}
        </>
    );
};

export { NavigationListSection };
